import { createSelector } from 'reselect';
import { Selectors, State } from '@grandvisionhq/auth';
import { idleState, uninitState } from '@grandvisionhq/state';
import { getMyAccount } from '../selectors.js';

const getSubscriptions = createSelector(getMyAccount, Selectors.getAuth, (myAccount, auth)=>State.isLoggedIn(auth) ? myAccount.subscriptions : undefined
);
const getSubscriptionDetail = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.detail : undefined
);
const getSubscriptionForm = createSelector(getSubscriptions, (subscription)=>{
    return subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionForm;
});
const getSubscriptionDetailCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.detailCall : idleState()
);
const getPauseCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.pauseCall : idleState()
);
const getQuantityCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.quantityCall : idleState()
);
const getProductDataCall = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.productDataCall : idleState()
);
const getProductData = createSelector(getSubscriptions, (subscription)=>subscription ? subscription.productData : {}
);
const getSubscriptionList = createSelector(getSubscriptions, (subscriptions)=>subscriptions ? subscriptions.list : uninitState()
);

export { getPauseCall, getProductData, getProductDataCall, getQuantityCall, getSubscriptionDetail, getSubscriptionDetailCall, getSubscriptionForm, getSubscriptionList, getSubscriptions };
//# sourceMappingURL=selectors.js.map
